import { Spin } from 'antd';
import './page-loader.styles.less';

export const PageLoader = () => (
  <div className="page-loader flex justify-content-center align-items-center">
    <Spin size="large" />
  </div>
);
